"use client";
import { cn } from "@/lib/utils";
import ProgramEnrollButton, {
  ProgramEnrollButtonProps,
} from "../../../components/ProgramEnrollButton";
import useTranslations from "@/i18n/useTranslations";
type ProgramMidPageCTA = ProgramEnrollButtonProps & {
  className?: string;
};
export default function MidPageCTA(props: ProgramMidPageCTA) {
  const t = useTranslations("Course");
  return (
    <div className={cn("flex flex-col text-center gap-4", props.className)}>
      <h2 className="md:text-3xl font-bold my-0">
        {t("readyToAdvanceCareer")}
      </h2>
      <div className="self-center w-full sm:w-auto px-6">
        <ProgramEnrollButton {...props} />
      </div>
    </div>
  );
}
